import React from 'react';
const TalkSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      className={className}
      {...props}
    >
      <rect
        x="0.492188"
        width="27.9964"
        height="28"
        rx="13.9982"
        fill={color}
      />
      <path
        d="M17.9513 8H8.66565C8.0186 8 7.49219 8.52675 7.49219 9.17425V16.6828C7.49219 17.3303 8.0186 17.857 8.66565 17.857H10.0168L9.37862 19.2278C9.19493 19.6224 9.61217 20.0215 9.99617 19.8343L14.0506 17.857H17.9513C18.5984 17.857 19.1248 17.3303 19.1248 16.6828V9.17425C19.1247 8.52675 18.5983 8 17.9513 8ZM16.7064 15.3775H9.91054C9.65696 15.3775 9.45138 15.1719 9.45138 14.9183C9.45138 14.6647 9.65696 14.4591 9.91054 14.4591H16.7064C16.96 14.4591 17.1656 14.6647 17.1656 14.9183C17.1656 15.1719 16.96 15.3775 16.7064 15.3775ZM16.7064 13.3877H9.91054C9.65696 13.3877 9.45138 13.1821 9.45138 12.9285C9.45138 12.6749 9.65696 12.4694 9.91054 12.4694H16.7064C16.96 12.4694 17.1656 12.6749 17.1656 12.9285C17.1656 13.1821 16.96 13.3877 16.7064 13.3877ZM16.7064 11.3979H9.91054C9.65696 11.3979 9.45138 11.1923 9.45138 10.9388C9.45138 10.6852 9.65696 10.4796 9.91054 10.4796H16.7064C16.96 10.4796 17.1656 10.6852 17.1656 10.9388C17.1656 11.1923 16.96 11.3979 16.7064 11.3979Z"
        fill="white"
      />
      <path
        d="M20.7081 10.143H20.1972C20.1126 10.143 20.0441 10.2115 20.0441 10.296V16.6829C20.0441 17.8368 19.1057 18.7756 17.9523 18.7756H14.2988C14.2756 18.7756 14.2526 18.7808 14.2317 18.791L12.9611 19.4107C12.8667 19.4568 12.8454 19.5824 12.9198 19.6567C13.1321 19.8687 13.425 20 13.748 20H20.7075C21.3555 20 21.8808 19.4747 21.8808 18.8267V11.3175C21.8808 10.6699 21.3547 10.143 20.7081 10.143Z"
        fill="white"
      />
    </svg>
  );
};

export default TalkSVG;
